import * as WebSocket from 'ws';
import { EpxWebsocketClient } from './epx-websocket-client';
export interface EpxWebsocketServer extends WebSocket.Server {
  clients: Set<EpxWebsocketClient>;
}
